module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_perform.js
// module id = 118
// module chunks = 1